<template>
	<div>
		<EgrantySectionDivider
			text="Tytuł"
			icon="description"
		></EgrantySectionDivider>
    
		<OfferNameInput
			style="padding: 20px 20px 5px 20px"
			:name.sync="internalTitle"
			:readonly="readonly"
			label="Polski tytuł"
			ref="polishName"
		></OfferNameInput>

		<OfferNameInput
			style="padding: 5px 20px 20px 20px"
			:name.sync="internalEnglishTitle"
			:readonly="readonly"
			label="Angielski tytuł"
			ref="englishName"
		></OfferNameInput>

		<PriorityTree
			v-model="internalPrioritiesData"
			:contest-id="contestId"
			:many-accreditation-countries="contestConfiguration.manyAccreditationCountries"
			:many-areas="contestConfiguration.manyAreas"
			:many-priorities="contestConfiguration.manyPriorities"
			:many-tasks="contestConfiguration.manyTasks"
			@countriesChanged="countriesChanged()"
			:readonly="readonly"
			ref="priorityTree"
		></PriorityTree>

		<OfferOtherBidders
			v-model="internalOtherBiddersId"
			:mutual-offer="internalMutualOffer"
			@change="(val) => mutualOfferChanged(val)"
			@biddersChanged="setBiddersChanged()"
			:readonly="readonly"
			ref="offerOtherBidders"
		></OfferOtherBidders>
	</div>
</template>

<script>
import PriorityTree from "@/view/logged/offer/components/PriorityTree";
import OfferOtherBidders from "@/view/logged/offer/components/OfferOtherBidders";
import EgrantySectionDivider from "@/genericComponents/EgrantySectionDivider";
import OfferNameInput from "@/view/logged/offer/components/OfferNameInput";

export default {
  name: "ContestOfferMainData",

  components: {OfferNameInput, EgrantySectionDivider, OfferOtherBidders, PriorityTree},

  data() {
    return {
      internalTitle: '',
      internalEnglishTitle: '',
      internalPrioritiesData: {},
      internalOtherBiddersId: [],
      internalMutualOffer: false,
    };
  },

  methods: {
    setBiddersChanged() {
      this.$emit("biddersChanged");
    },

    countriesChanged() {
      this.$emit("countriesChanged");
    },

    mutualOfferChanged(val) {
      this.$emit("mutualOfferChanged", val);
    },

    validateExistingRef(name) {
      if (this.$refs[name] === undefined) {
        return true;
      }
      if (typeof this.$refs[name]["validate"] !== "function") {
        return true;
      }
      return this.$refs[name].validate();
    },

    validate() {
      let valid = this.validateExistingRef("polishName");
      valid &= this.validateExistingRef("englishName");
      valid &= this.validateExistingRef("priorityTree");
      valid &= this.validateExistingRef("offerOtherBidders");
      return valid;
    }
  },

  watch: {
    title: {
      immediate: true,
      handler(value) {
        this.internalTitle = value;
      }
    },

    internalTitle: {
      immediate: true,
      handler(value) {
        this.$emit("update:title", value);
      }
    },

    englishTitle: {
      immediate: true,
      handler(value) {
        this.internalEnglishTitle = value;
      }
    },

    internalEnglishTitle: {
      immediate: true,
      handler(value) {
        this.$emit("update:englishTitle", value);
      }
    },

    prioritiesData: {
      immediate: true,
      handler(value) {
        this.internalPrioritiesData = value;
      }
    },

    internalPrioritiesData: {
      immediate: true,
      handler(value) {
        this.$emit("update:prioritiesData", value);
      }
    },

    otherBiddersId: {
      immediate: true,
      handler(value) {
        this.internalOtherBiddersId = value;
      }
    },

    internalOtherBiddersId: {
      immediate: true,
      handler(value) {
        this.$emit("update:otherBiddersId", value);
      }
    },

    mutualOffer: {
      immediate: true,
      handler(value) {
        this.internalMutualOffer = value;
      }
    },

    internalMutualOffer: {
      immediate: true,
      handler(value) {
        this.$emit("update:mutualOffer", value);
      }
    },
  },

  props: {
    readonly: {type: Boolean, required: true},
    contestConfiguration: {type: Object, required: true},
    contestId: {required: true},
    title: {type: String, required: true},
    englishTitle: {type: String, required: true},
    prioritiesData: {type: Object, required: true},
    otherBiddersId: {type: Array, required: true},
    mutualOffer: {type: Boolean, required: true},
  }
};
</script>

<style scoped>

</style>